/* Centralised test IDs */
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  brand: "nav-brand",
  cta: "nav-cta",
};

export const HERO = {
  cta: "hero-cta",
};

export const FORM = {
  section: "intake-form",
  firstName: "intake-first-name",
  lastName: "intake-last-name",
  email: "intake-email",
  phone: "intake-phone",
  notes: "intake-notes",
  submit: "intake-submit",
  thankYou: "intake-thank-you",
  chip: (group, value) => `chip-${group}-${value.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`,
};

export const GUIDES = {
  card: (id) => `guide-card-${id}`,
  modal: "guide-checkout-modal",
  close: "guide-checkout-close",
  firstName: "guide-checkout-first-name",
  email: "guide-checkout-email",
  submit: "guide-checkout-submit",
  downloadPage: "guide-download-page",
  downloadBtn: "guide-download-btn",
  error: "guide-download-error",
};

export const PACKAGES = {
  cta: (id) => `package-cta-${id}`,
  modal: "package-checkout-modal",
  close: "package-checkout-close",
  price: "package-checkout-price",
  firstName: "package-checkout-first-name",
  lastName: "package-checkout-last-name",
  email: "package-checkout-email",
  submit: "package-checkout-submit",
  confirmationPage: "package-confirmation-page",
  error: "package-confirmation-error",
};

export const ADMIN = {
  loginInput: "admin-password",
  loginBtn: "admin-login-btn",
  filter: (key) => `admin-filter-${key}`,
  statCard: (key) => `admin-stat-${key}`,
  exportCsv: "admin-export-csv",
  leadCard: (id) => `admin-lead-${id}`,
  statusSelect: (id) => `admin-status-${id}`,
  markSettled: (id) => `admin-mark-settled-${id}`,
  tab: (key) => `admin-tab-${key}`,
  salesStat: (key) => `admin-sales-stat-${key}`,
  salesRow: (id) => `admin-sales-row-${id}`,
};

export const PORTAL = {
  loginEmail: "portal-login-email",
  loginSubmit: "portal-login-submit",
  loginSent: "portal-login-sent",
  dashboard: "portal-dashboard",
  signOut: "portal-sign-out",
  agreementBlock: "portal-agreement",
  agreementPreview: "portal-agreement-preview",
  agreementName: "portal-agreement-name",
  agreementSign: "portal-agreement-sign",
  agreementDownload: "portal-agreement-download",
  checklist: "portal-checklist",
  checklistStep: (id) => `portal-checklist-${id}`,
  docs: "portal-docs",
  docCategory: (id) => `portal-doc-category-${id}`,
  docUpload: (id) => `portal-upload-${id}`,
  docRow: (id) => `portal-doc-${id}`,
};

export const ADMIN_CLIENTS = {
  tab: "admin-clients-tab",
  table: "admin-clients-table",
  row: (id) => `admin-client-row-${id}`,
  open: (id) => `admin-client-open-${id}`,
  backfillBtn: "admin-clients-backfill",
  backToList: "admin-clients-back",
  notes: "admin-client-notes",
  notesSave: "admin-client-notes-save",
  flagToggle: "admin-client-flag",
  resendLink: "admin-client-resend-link",
  checklistStep: (id) => `admin-client-checklist-${id}`,
  docDownload: (id) => `admin-client-doc-download-${id}`,
  docReview: (id) => `admin-client-doc-review-${id}`,
};

export const WORKSPACE = {
  root: "admin-workspace",
  businessSwitch: (biz) => `workspace-biz-${biz}`,
  subTab: (key) => `workspace-tab-${key}`,
  statCard: (k) => `workspace-stat-${k}`,
  candidateRow: (id) => `workspace-candidate-row-${id}`,
  candidateOpen: (id) => `workspace-candidate-open-${id}`,
  employerRow: (id) => `workspace-employer-row-${id}`,
  employerOpen: (id) => `workspace-employer-open-${id}`,
  personRow: (id) => `workspace-person-row-${id}`,
  createCandidateBtn: "workspace-new-candidate",
  createEmployerBtn: "workspace-new-employer",
  formEmail: "workspace-form-email",
  formFirstName: "workspace-form-first-name",
  formLastName: "workspace-form-last-name",
  formPhone: "workspace-form-phone",
  formCandidateType: "workspace-form-candidate-type",
  formVisaStatus: "workspace-form-visa-status",
  formIndustry: "workspace-form-industry",
  formLocationNow: "workspace-form-location-now",
  formLocationTarget: "workspace-form-location-target",
  formSkills: "workspace-form-skills",
  formYearsExperience: "workspace-form-years",
  formTags: "workspace-form-tags",
  formNotes: "workspace-form-notes",
  formCompanyName: "workspace-form-company-name",
  formCompanyDomain: "workspace-form-company-domain",
  formContactEmail: "workspace-form-contact-email",
  formContactFirstName: "workspace-form-contact-first-name",
  formHiringFor: "workspace-form-hiring-for",
  formSubmit: "workspace-form-submit",
  formCancel: "workspace-form-cancel",
  search: "workspace-search",
  filterCandidateType: "workspace-filter-candidate-type",
};

export const MEMBERS = {
  joinCta: "members-join-cta",
  promoBar: "members-promo-bar",
  promoLogin: "members-promo-login",
  promoSignup: "members-promo-signup",
  modal: "members-subscribe-modal",
  modalClose: "members-modal-close",
  firstName: "members-subscribe-first-name",
  email: "members-subscribe-email",
  submit: "members-subscribe-submit",
  planToggle: "members-plan-toggle",
  planOption: (id) => `members-plan-${id}`,
  loginEmail: "members-login-email",
  loginSubmit: "members-login-submit",
  loginSent: "members-login-sent",
  dashboard: "members-dashboard",
  guideRow: (id) => `members-guide-${id}`,
  downloadBtn: (id) => `members-download-${id}`,
  managePortal: "members-manage-portal",
  socialLinkedin: "footer-social-linkedin",
  socialInstagram: "footer-social-instagram",
  paypalBtn: "members-paypal-btn",
};
